// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__Settings__TestConnectionController from "./admin/settings/test_connection_controller"
application.register("admin--settings--test-connection", Admin__Settings__TestConnectionController)

import Admin__SidebarController from "./admin/sidebar_controller"
application.register("admin--sidebar", Admin__SidebarController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BusinessEinDecodeController from "./business_ein_decode_controller"
application.register("business-ein-decode", BusinessEinDecodeController)

import CreditScoreDecodeController from "./credit_score_decode_controller"
application.register("credit-score-decode", CreditScoreDecodeController)

import DevopsDashboard__AutoRefreshController from "./devops_dashboard/auto_refresh_controller"
application.register("devops-dashboard--auto-refresh", DevopsDashboard__AutoRefreshController)

import DevopsDashboard__DashboardController from "./devops_dashboard/dashboard_controller"
application.register("devops-dashboard--dashboard", DevopsDashboard__DashboardController)

import DevopsDashboard__EnvironmentFilterController from "./devops_dashboard/environment_filter_controller"
application.register("devops-dashboard--environment-filter", DevopsDashboard__EnvironmentFilterController)

import DevopsDashboard__KeyboardShortcutsController from "./devops_dashboard/keyboard_shortcuts_controller"
application.register("devops-dashboard--keyboard-shortcuts", DevopsDashboard__KeyboardShortcutsController)

import DevopsDashboard__LogViewerController from "./devops_dashboard/log_viewer_controller"
application.register("devops-dashboard--log-viewer", DevopsDashboard__LogViewerController)

import DevopsDashboard__MetricsChartController from "./devops_dashboard/metrics_chart_controller"
application.register("devops-dashboard--metrics-chart", DevopsDashboard__MetricsChartController)

import DevopsDashboard__SparklineController from "./devops_dashboard/sparkline_controller"
application.register("devops-dashboard--sparkline", DevopsDashboard__SparklineController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LoanApplications__ConditionalOwnerController from "./loan_applications/conditional_owner_controller"
application.register("loan-applications--conditional-owner", LoanApplications__ConditionalOwnerController)

import LoanApplications__EinAutofillController from "./loan_applications/ein_autofill_controller"
application.register("loan-applications--ein-autofill", LoanApplications__EinAutofillController)

import LoanApplications__FormController from "./loan_applications/form_controller"
application.register("loan-applications--form", LoanApplications__FormController)

import LoanApplications__SsnAutofillController from "./loan_applications/ssn_autofill_controller"
application.register("loan-applications--ssn-autofill", LoanApplications__SsnAutofillController)

import LoanApplications__SsnFieldController from "./loan_applications/ssn_field_controller"
application.register("loan-applications--ssn-field", LoanApplications__SsnFieldController)

import MfaController from "./mfa_controller"
application.register("mfa", MfaController)

import PasswordGeneratorController from "./password_generator_controller"
application.register("password-generator", PasswordGeneratorController)

import PasswordRevealController from "./password_reveal_controller"
application.register("password-reveal", PasswordRevealController)

import SessionDebugController from "./session_debug_controller"
application.register("session-debug", SessionDebugController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
